<script setup>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { updateUserPassword } from '../helpers/api'

const route = useRoute()
const router = useRouter()
const password = ref('')
const confirmPassword = ref('')
// debugger
const resetPassword = async () => {
  const response = await updateUserPassword(
    route.query.token,
    password.value,
    confirmPassword.value,
  )
  if (response.status === 200) {
    router.push('/login')
  }
}
</script>
<template>
  <div class="container mx-auto p-4 md:pt-12 ">
      <form>
          <div class="mb-6">
              <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Password</label>
              <input type="password" id="password" v-model="password"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="•••••••••" required>
          </div>
          <div class="mb-6" >
              <label for="confirm_password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Confirm
                  password</label>
              <input type="password" id="confirm_password" v-model="confirmPassword"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="•••••••••" required>
          </div>
          <button 
              class="min-w-20 text-white bg-primary hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" 
             type="button" @click="resetPassword">Reset Password</button>

      </form>
  </div>
</template>